import {
  createGetVillageForMapModel,
  IGetVillageForMapError,
  IGetVillageForMapResponse,
} from '@cian/api-models/countryside-search/v1/get-village-for-map';
import { IHttpApi } from '@cian/http-api/shared';
import { ILogger } from '@cian/logger';
import { HttpTimeoutError } from '@cian/peperrors/shared';

export async function getVillage(httpApi: IHttpApi, id: number, logger?: ILogger, timeout: number = 1000) {
  try {
    const { response, statusCode } = await httpApi.fetch(createGetVillageForMapModel({ parameters: { id } }), {
      ecnhancersConfig: {
        timeout,
      },
    });

    if (
      statusCode !== 200 ||
      isResponseContainsKey<IGetVillageForMapError, IGetVillageForMapResponse>(response, 'errors')
    ) {
      throw response;
    }

    return response;
  } catch (error) {
    if (logger) {
      logger.error(error, {
        message: error instanceof HttpTimeoutError ? 'TimeoutError in getVillage' : 'Error in getVillage',
      });
    }

    return null;
  }
}

function isResponseContainsKey<S, E>(response: S | E, key: string): response is S {
  return key in (response as S);
}
